module.exports = function() {
  return new Worker(__webpack_public_path__ + "122390809070a72e9efd.worker.js");
};